import type { Resource } from './types';

export const resourcesTutorial: Resource[] = [
  {
    id: 't-js',
    title: '零基础 JavaScript 入门教程',
    category: 'tutorial',
    subCategory: 'code',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20educational%20illustration%20of%20JavaScript%20learning%20with%20floating%20curly%20braces%20and%20code%20cards%2C%20soft%20warm%20background%2C%20teal%20green%20accent%2C%20friendly%20flat%20vector%20style%2C%20clean%20modern%20composition%2C%20high%20detail&width=800&height=500&seq=cov-t1&orientation=landscape',
    summary: '从变量到异步，用 6 节课带你完整入门 JavaScript，配练习与答案。',
    description: '本教程面向完全没有编程经验的学习者，用通俗的语言和大量生活化例子讲解 JavaScript 的核心概念。从变量、条件、循环到函数、数组、对象，再到 DOM 操作与异步编程，每一节都配有可运行示例和课后练习。学完后你能独立完成小游戏、计算器等实用小项目。',
    author: '前端小路',
    source: '免费91 编辑精选',
    publishedAt: '2026-09-24',
    views: 72430,
    favorites: 6120,
    tags: ['JavaScript', '编程入门', '前端'],
    chapters: [
      { id: 't-js-1', title: '第 1 课 · 认识 JavaScript 与开发环境', duration: '18:20' },
      { id: 't-js-2', title: '第 2 课 · 变量、数据类型与运算符', duration: '22:45' },
      { id: 't-js-3', title: '第 3 课 · 条件判断与循环', duration: '25:10' },
      { id: 't-js-4', title: '第 4 课 · 函数与作用域', duration: '20:35' },
      { id: 't-js-5', title: '第 5 课 · 数组与对象的常用操作', duration: '27:50' },
      { id: 't-js-6', title: '第 6 课 · DOM 操作与异步初步', duration: '31:15' },
    ],
  },
  {
    id: 't-excel',
    title: 'Excel 高效办公实战教程',
    category: 'tutorial',
    subCategory: 'office-skill',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20spreadsheet%20tables%20and%20charts%20on%20a%20soft%20warm%20background%2C%20teal%20green%20and%20amber%20accents%2C%20clean%20flat%20vector%20style%2C%20organized%20grid%20composition%2C%20editorial%20educational%20look%2C%20high%20detail&width=800&height=500&seq=cov-t2&orientation=landscape',
    summary: '职场人必备：透视表、函数、图表一次讲透，让报表处理快 10 倍。',
    description: '本教程围绕真实办公场景设计，系统讲解 Excel 的核心技能：数据规范、常用函数、数据透视表、条件格式与动态图表。每个知识点都配有可直接套用的模板与案例文件，帮助你摆脱手工统计的烦恼。课程适合行政、财务、运营等需要频繁处理表格的职场人士。',
    author: '办公效率君',
    source: '免费91 编辑精选',
    publishedAt: '2026-09-16',
    views: 58320,
    favorites: 4810,
    tags: ['Excel', '办公技能', '数据'],
    chapters: [
      { id: 't-excel-1', title: '第 1 课 · 数据录入规范与快捷键', duration: '16:40' },
      { id: 't-excel-2', title: '第 2 课 · 常用函数速查与实战', duration: '28:05' },
      { id: 't-excel-3', title: '第 3 课 · 查找与引用函数进阶', duration: '24:30' },
      { id: 't-excel-4', title: '第 4 课 · 数据透视表入门到精通', duration: '32:15' },
      { id: 't-excel-5', title: '第 5 课 · 条件格式与数据可视化', duration: '21:50' },
      { id: 't-excel-6', title: '第 6 课 · 动态图表与自动化报表', duration: '26:20' },
    ],
  },
  {
    id: 't-ps',
    title: 'Photoshop 平面设计基础教程',
    category: 'tutorial',
    subCategory: 'design-tut',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20graphic%20design%20tools%20with%20color%20swatches%20and%20layers%2C%20soft%20warm%20neutral%20background%2C%20teal%20and%20orange%20accents%2C%20modern%20flat%20vector%20style%2C%20tidy%20creative%20composition%2C%20high%20detail&width=800&height=500&seq=cov-t3&orientation=landscape',
    summary: '从图层到合成，手把手带你掌握 PS 修图与海报设计的完整流程。',
    description: '本教程为零基础设计爱好者量身定制，从界面认识、图层与蒙版，到抠图、调色、文字排版与创意合成，完整覆盖平面设计的常用技能。课程以实际项目为主线，带你一步步完成个人海报、商品主图与社交媒体配图，学完即可独立产出作品。',
    author: '设计自习室',
    source: '免费91 编辑精选',
    publishedAt: '2026-09-08',
    views: 49680,
    favorites: 4030,
    tags: ['Photoshop', '设计', '海报'],
    chapters: [
      { id: 't-ps-1', title: '第 1 课 · 界面认识与基础操作', duration: '19:10' },
      { id: 't-ps-2', title: '第 2 课 · 选区、图层与蒙版', duration: '26:35' },
      { id: 't-ps-3', title: '第 3 课 · 抠图与图像修复', duration: '23:50' },
      { id: 't-ps-4', title: '第 4 课 · 调色与光影处理', duration: '29:20' },
      { id: 't-ps-5', title: '第 5 课 · 文字排版与版式设计', duration: '25:05' },
      { id: 't-ps-6', title: '第 6 课 · 综合实战：商业海报合成', duration: '38:40' },
    ],
  },
  {
    id: 't-english',
    title: '实用英语口语入门 30 讲',
    category: 'tutorial',
    subCategory: 'language',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20language%20learning%20with%20speech%20bubbles%20and%20letters%20floating%2C%20soft%20warm%20background%2C%20teal%20green%20accent%2C%20friendly%20flat%20vector%20style%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=500&seq=cov-t4&orientation=landscape',
    summary: '围绕日常场景的口语课，跟读练习 + 纠音，告别“哑巴英语”。',
    description: '本课程精选生活中最高频的 30 个交流场景，如点餐、问路、面试、闲聊等，每讲聚焦一组实用句型与地道表达。课程强调“听—跟读—纠音”的闭环训练，配有慢速与常速音频，帮助你逐步建立语感与开口自信。适合有一定词汇基础、希望提升口语的学习者。',
    author: '开口说英语',
    source: '免费91 编辑精选',
    publishedAt: '2026-08-28',
    views: 41260,
    favorites: 3290,
    tags: ['英语', '口语', '语言学习'],
    chapters: [
      { id: 't-en-1', title: '第 1 讲 · 打招呼与自我介绍', duration: '14:20' },
      { id: 't-en-2', title: '第 2 讲 · 餐厅点餐与结账', duration: '15:45' },
      { id: 't-en-3', title: '第 3 讲 · 问路与乘坐交通', duration: '13:30' },
      { id: 't-en-4', title: '第 4 讲 · 购物与讨价还价', duration: '16:10' },
      { id: 't-en-5', title: '第 5 讲 · 酒店入住与退房', duration: '14:55' },
      { id: 't-en-6', title: '第 6 讲 · 面试常用表达', duration: '18:35' },
    ],
  },
  {
    id: 't-cook',
    title: '家常菜烹饪入门教程',
    category: 'tutorial',
    subCategory: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20minimal%20illustration%20of%20home%20cooking%20with%20fresh%20vegetables%20and%20a%20pan%20on%20a%20soft%20neutral%20background%2C%20teal%20green%20and%20amber%20accents%2C%20clean%20flat%20vector%20style%2C%20cozy%20editorial%20composition%2C%20high%20detail&width=800&height=500&seq=cov-t5&orientation=landscape',
    summary: '厨房小白也能学会的 20 道家常菜，步骤清晰，附食材选购技巧。',
    description: '本教程专为厨房新手准备，从刀工、火候、调味等基本功讲起，逐步带你完成番茄炒蛋、红烧肉、酸辣土豆丝等 20 道经典家常菜。每道菜都标注了食材用量、关键步骤与常见失败原因，并附上食材挑选与保存的小技巧，让你做一次就上手。',
    author: '一人食厨房',
    source: '免费91 编辑精选',
    publishedAt: '2026-08-20',
    views: 35740,
    favorites: 2560,
    tags: ['烹饪', '家常菜', '生活'],
    chapters: [
      { id: 't-cook-1', title: '第 1 讲 · 厨房基本功：刀工与火候', duration: '17:30' },
      { id: 't-cook-2', title: '第 2 讲 · 十分钟快手菜四道', duration: '21:15' },
      { id: 't-cook-3', title: '第 3 讲 · 一锅到底的炖菜', duration: '19:40' },
      { id: 't-cook-4', title: '第 4 讲 · 家常小炒与调味', duration: '23:05' },
      { id: 't-cook-5', title: '第 5 讲 · 汤羹与主食搭配', duration: '18:25' },
    ],
  },
  {
    id: 't-photo',
    title: '手机摄影构图与后期教程',
    category: 'tutorial',
    subCategory: 'life',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20smartphone%20photography%20with%20a%20camera%20frame%20grid%20and%20lens%2C%20soft%20warm%20background%2C%20teal%20and%20orange%20accents%2C%20modern%20flat%20vector%20style%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=500&seq=cov-t6&orientation=landscape',
    summary: '不用单反，一部手机拍出高级感，构图、用光、调色全攻略。',
    description: '本教程告诉你如何用手机拍出更有质感的照片。内容涵盖构图法则、光线运用、人像与风景拍摄技巧，以及常用的手机修图思路，包括调色、裁切与画面减法的技巧。课程强调可操作性，每讲都有对比案例，让你看完就能立刻用手机实践。',
    author: '随手拍工作室',
    source: '免费91 编辑精选',
    publishedAt: '2026-08-12',
    views: 32890,
    favorites: 2340,
    tags: ['摄影', '手机', '修图'],
    chapters: [
      { id: 't-photo-1', title: '第 1 讲 · 手机相机的基础设置', duration: '15:20' },
      { id: 't-photo-2', title: '第 2 讲 · 构图法则与画面平衡', duration: '22:40' },
      { id: 't-photo-3', title: '第 3 讲 · 光线的运用与氛围', duration: '20:10' },
      { id: 't-photo-4', title: '第 4 讲 · 人像与风景拍摄技巧', duration: '24:35' },
      { id: 't-photo-5', title: '第 5 讲 · 手机修图与调色思路', duration: '26:50' },
    ],
  },
  {
    id: 't-python',
    title: 'Python 数据分析入门教程',
    category: 'tutorial',
    subCategory: 'code',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20data%20analysis%20with%20floating%20charts%20and%20a%20snake%20python%20symbol%20on%20a%20soft%20warm%20background%2C%20teal%20green%20and%20amber%20accents%2C%20modern%20flat%20vector%20style%2C%20clean%20editorial%20composition%2C%20high%20detail&width=800&height=500&seq=cov-t8&orientation=landscape',
    summary: '用 Python + Pandas 处理真实数据集，从清洗到可视化一气呵成。',
    description: '本教程以真实数据集为案例，带你掌握 Python 数据分析的完整流程：数据读取与清洗、缺失值处理、分组统计、透视分析以及图表可视化。课程重点讲解 Pandas 与 Matplotlib 的常用用法，弱化枯燥语法，强调“边做边学”。学完你能独立完成一份数据分析报告。',
    author: '数据小课',
    source: '免费91 编辑精选',
    publishedAt: '2026-08-04',
    views: 38920,
    favorites: 3060,
    tags: ['Python', '数据分析', 'Pandas'],
    chapters: [
      { id: 't-py-1', title: '第 1 课 · 环境准备与数据结构', duration: '18:50' },
      { id: 't-py-2', title: '第 2 课 · 数据读取与清洗', duration: '25:30' },
      { id: 't-py-3', title: '第 3 课 · 筛选、排序与分组统计', duration: '27:15' },
      { id: 't-py-4', title: '第 4 课 · 透视表与多表合并', duration: '23:40' },
      { id: 't-py-5', title: '第 5 课 · 数据可视化入门', duration: '29:05' },
      { id: 't-py-6', title: '第 6 课 · 综合实战：分析报告输出', duration: '34:20' },
    ],
  },
];